import React from 'react';
import { BatteryWarning, CheckCircle2 } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-8 md:py-16 px-4 bg-dark-900 border-t border-dark-800" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        {/* The Problem */}
        <div className="text-center mb-10 md:mb-16" data-id="element-93">
          <h2 className="text-xl md:text-4xl font-black mb-6 md:mb-8 text-white leading-snug md:leading-tight max-w-4xl mx-auto" data-id="element-94">
            La parte más difícil de empezar un emprendimiento no es fabricar los
            productos...
            <span className="text-brand-400 block mt-3 md:mt-2 text-2xl md:text-5xl" data-id="element-95">
              Es saber exactamente qué hacer para no perder tiempo ni dinero.
            </span>
          </h2>

          <p className="text-sm md:text-xl text-gray-300 mb-6 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-96">
            Si alguna vez pensaste en fabricar productos de limpieza seguramente
            te pasó algo de esto:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 text-left max-w-2xl mx-auto mb-8 md:mb-12" data-id="element-97">
            {['Buscaste fórmulas en internet.', 'Encontraste recetas diferentes para el mismo producto.', 'No sabías qué ingredientes comprar.', 'No sabías dónde conseguir materias primas.', 'No estabas seguro de si la fórmula funcionaba.', 'No sabías cuánto cobrar ni cómo empezar a vender.'].map((item, i) => <div key={i} className="flex items-center gap-2 md:gap-3 bg-red-900/20 p-3 md:p-4 rounded-lg border border-red-900/50" data-id="element-98">
                <BatteryWarning className="text-red-400 shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-99" />
                <span className="font-semibold text-gray-200 text-sm md:text-lg" data-id="element-100">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-lg md:text-2xl font-bold text-white mb-2 md:mb-4" data-id="element-101">
            Y mientras más información buscabas...
          </p>
          <p className="text-xl md:text-3xl font-black text-red-400 uppercase" data-id="element-102">
            Más confundido terminabas.
          </p>
        </div>

        {/* The Transition / Solution */}
        <div className="bg-dark-800 border-2 border-brand-500/30 rounded-2xl p-6 md:p-12 text-center shadow-lg" data-id="element-103">
          <h3 className="text-lg md:text-2xl font-bold mb-4 text-gray-300" data-id="element-104">
            Necesitás una forma más simple de empezar.
          </h3>

          <div className="w-16 md:w-24 h-1 bg-brand-500 mx-auto my-6 md:my-8" data-id="element-105"></div>

          <p className="text-base md:text-xl font-medium mb-2 md:mb-4 text-gray-400" data-id="element-106">
            Por eso creamos el
          </p>
          <h2 className="text-2xl md:text-5xl font-black text-brand-400 mb-6 md:mb-8 uppercase leading-tight" data-id="element-107">
            Manual de Fórmulas para Productos de Limpieza
          </h2>

          <p className="text-lg md:text-3xl font-black text-brand-300 mb-4 md:mb-8" data-id="element-108">
            No es una colección de recetas sueltas.
          </p>
          <p className="text-base md:text-xl mb-6 md:mb-8 text-gray-300" data-id="element-109">
            Es un sistema práctico para aprender a fabricar productos de
            limpieza y convertir ese conocimiento en una{' '}
            <span className="text-brand-400 font-bold" data-id="element-110">
              oportunidad real de ingresos
            </span>
            . Porque cuando tenés una guía clara:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 max-w-2xl mx-auto text-left" data-id="element-111">
            {['Sabés exactamente qué comprar.', 'Sabés exactamente qué fabricar.', 'Sabés cuánto invertir.', 'Sabés cuánto cobrar.', 'Podés comenzar mucho más rápido.'].map((item, i) => <div key={i} className="flex items-center gap-2 md:gap-3 bg-dark-900 p-3 md:p-4 rounded-lg border border-dark-700 shadow-sm" data-id="element-112">
                <CheckCircle2 className="text-brand-400 shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-113" />
                <span className="font-bold text-sm md:text-lg text-gray-200" data-id="element-114">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="mt-6 md:mt-8 text-base md:text-lg font-bold text-white uppercase tracking-widest" data-id="element-115">
            Y <span className="text-brand-400" data-id="element-116">evitás errores costosos</span>{' '}
            que frenan a la mayoría de los emprendedores.
          </p>
        </div>
      </div>
    </section>;
}